import {useSprintsRedux} from 'hooks';
import {useBoardRedux} from 'hooks/board';
import {ItemDataCreateRequest} from 'models/board/itemData';
import {KeyboardEvent, useMemo, useState} from 'react';

export const useAddKanbanItem = (columnId: string) => {
    const {selectedSprint} = useSprintsRedux();
    const {selectedBoard, selectedDefaultForm} = useBoardRedux();

    const fields = useMemo(() => {
        return selectedDefaultForm?.formFieldsData ?? [];
    }, [selectedDefaultForm]);

    const [addTaskBoxOpenState, setAddTaskBox] = useState(false);

    const closeAddTaskContainer = () => {
        setAddTaskBox(false);
    };
    const openAddTAskContainer = () => {
        setAddTaskBox(true);
    };

    const handleAddTask = (event: KeyboardEvent<HTMLInputElement>, value: string) => {
        if (event.key === 'Enter') {
            getNewlyCreatedItemWithTitleSetToTheFirstField(value);
        }
        if (event.key === 'Escape') {
            closeAddTaskContainer();
        }
    };

    const getNewlyCreatedItemWithTitleSetToTheFirstField = (title: string): ItemDataCreateRequest => {
        const fieldData = selectedDefaultForm?.formFieldsData.map(x => {
            const {...rest} = x;
            if (x.shouldUseAsTheFieldToCreateItem) {
                return {
                    ...rest,
                    value: {...rest.value, value: title},
                };
            }
            return rest;
        });

        const inputData: ItemDataCreateRequest = {
            data: fieldData ?? [],
            itemStatusId: columnId,
            url: window.location.pathname,
            sprintId: selectedSprint?.id !== '' ? selectedSprint?.id : undefined,
            summaryViews: selectedDefaultForm?.summaryViews ?? [],
        };
        return inputData;
    };

    return {
        getNewlyCreatedItemWithTitleSetToTheFirstField,
        openAddTAskContainer,
        closeAddTaskContainer,
        handleAddTask,
        setAddTaskBox,
        addTaskBoxOpenState,
        fields: fields,
    };
};
